import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"normal","font-size":"14px"} }, "指标", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_7 = { class: "card-body pt-0" }
const _hoisted_8 = { class: "dataTables_wrapper dt-bootstrap4 no-footer" }
const _hoisted_9 = { class: "table-responsive" }

import {ref, onMounted, reactive, watch} from "vue";
import ApiService from "@/core/services/ApiService";
import {getCSSVariableValue} from "@/assets/ts/_utils";
import {parseTime} from "@/utils";

// 表格载入延迟

export default /*#__PURE__*/_defineComponent({
  props: {
  field: { type: String, required: true },  // 指定的指标字段
  data: {type: Object, required: true},  // 图形数据
  fields: {type: Array, required: true},  // 可选的所有指标
},
  setup(__props) {

const props = __props

const loading = ref<boolean>(false);
const chart = ref<HTMLElement | null>(null);

const filter = reactive({
  field: props.field,
});
const title = ref<string>('');
const labelColor = getCSSVariableValue("--bs-" + "gray-800");
const strokeColor = getCSSVariableValue("--bs-" + "gray-300");
const baseColor = getCSSVariableValue("--bs-" + "primary");
const lightColor = getCSSVariableValue("--bs-light-" + "primary");
const series = ref<Array<any>>([]);
const options = reactive({
  chart: {
    type: 'line',
    fontFamily: "inherit",
  },
  plotOptions: {},
  legend: {
    show: true,
    height: 50,
  },
  dataLabels: {
    enabled: false
  },
  fill: {
    type: "solid",
    opacity: 1,
  },
  stroke: {
    width: 2
  },
  xaxis: {
    type: 'category',
    categories: [],  //横坐标数组
    labels: {
      show: true,
      // rotate: 0,
    },
    tooltip: {
      enabled: false,
    },
  },
  yaxis: {
    min: 0,
    forceNiceScale: true,
  },
  colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#66DA26', '#7E36AF'],
});

onMounted(() => {
});

watch(props, (val) => {
  title.value = (props.fields as any[]).find(x => {return x['field'] === filter.field})['name'];
  if (JSON.stringify(props.data) !== '{}') {
    let fields = [] as string[];
    for (let f of props.fields as []) {
      fields.push(f['field']);
    }
    if (fields.indexOf(filter.field) === -1) {
      filter.field = fields[0];
    }
    loadData();
  }
});

// 数据载入
const loadData = () => {
  loading.value = true;
  let xfields = [];
  for (let k in props.data) {
    for (let d of props.data[k] as [])
    xfields.push(d['weekly'])
  }
  loading.value = false;
  options.xaxis.categories = [...xfields];
  (chart as any).value.updateOptions(options);
  changeSeries();
}

// 改变图表数据
const changeSeries = () => {
  title.value = (props.fields as any[]).find(x => {return x['field'] === filter.field})['name'];
  series.value = [];
  for (let k in props.data) {
    let d = {
      name: k,
      data: props.data[k].map((r) => r[filter.field]),
    };
    series.value.push(d);
  }
  (chart as any).value.updateSeries(series.value);
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(title.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _hoisted_6,
        _createVNode(_component_el_select, {
          modelValue: _unref(filter).field,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).field) = $event)),
          size: "small",
          placeholder: "请选择指标",
          onChange: changeSeries,
          style: {"width":"180px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.fields, (v) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                value: v['field'],
                key: v['field'],
                label: v['name']
              }, null, 8, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_apexchart, {
            ref_key: "chart",
            ref: chart,
            type: "line",
            height: "400",
            options: _unref(options),
            series: series.value,
            class: "mixed-widget-7-chart card-rounded-bottom"
          }, null, 8, ["options", "series"])
        ])
      ])
    ])
  ]))
}
}

})